import box, { boxVariants, BoxVariantsType } from './box';
import list, { listVariants, ListVariantsType } from './list';
import type { Product } from '../../../types/product';
import type { CustomTheme } from '../../../types/custom-theme';

const combobox = {
  box,
  list,
};

export const comboboxVariants = {
  box: boxVariants,
  list: listVariants,
};

export type ComboboxVariantsType = 'box' | 'list';

export interface ComboboxType {
  /** The Combobox subcomponent types. */
  SubComponents: {
    [K in ComboboxVariantsType]: Product.VariantKeyModes<
      K extends 'box' ? BoxVariantsType : K extends 'list' ? ListVariantsType : never
    >;
  };
  /** The Combobox component types. */
  Box: CustomTheme.VariantKeys<BoxVariantsType>;
  /** The Combobox.List component types. */
  List: CustomTheme.VariantKeys<ListVariantsType>;
}

export default combobox;
